import { render, staticRenderFns } from "./PermissionsActivitiesForm.vue?vue&type=template&id=15a02baa&scoped=true&"
import script from "./PermissionsActivitiesForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsActivitiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a02baa",
  null
  
)

export default component.exports